import { useContext } from "react";

import { SnackBarContext } from "../context/snackbar-provider";

const useSnackBars = () => useContext(SnackBarContext);

export default useSnackBars;
